/** FAQ, Support, and Advertising page copy (Finnish). */
export const pagesMessagesFi = {
  faq: {
    pageTitle: "Usein Kysytyt Kysymykset",
    pageSubtitle: "Löydä vastauksia WasOK:ta koskeviin yleisiin kysymyksiin",
    seoTitle: "UKK — WasOK",
    seoDescription:
      "Vastauksia yleisiin kysymyksiin WasOK:sta, tuotteiden skannauksesta, tietosuojasta ja arvioinneista.",
    items: [
      {
        question: "Miten WasOK toimii?",
        answer:
          "WasOK auttaa sinua muistamaan, mistä tuotteista pidit tai et pitänyt, skannaamalla viivakoodeja ja tallentamalla arviosi ja muistiinpanosi. Skannaa yksinkertaisesti tuotteen viivakoodi, arvioi se, lisää muistiinpanoja, ja seuraavalla kerralla kun skannaat saman tuotteen, näet heti aiemman arviosi.",
      },
      {
        question: "Tallennetaanko tietoni pilveen?",
        answer:
          "Ei! Kaikki tietosi tallennetaan paikallisesti laitteellesi. Emme synkronoi tietojasi pilveen, mikä tarkoittaa, että ostoshistoriasi ja tuotemielipiteesi pysyvät täysin yksityisinä. Tämä tarkoittaa kuitenkin myös, että sinun tulisi varmuuskopioida laitteesi, jos haluat säilyttää tietosi.",
      },
      {
        question: "Tarvitsenko internetyhteyttä käyttääkseni WasOK:ta?",
        answer:
          "Ei, WasOK toimii täysin offline-tilassa. Koska kaikki tietosi tallennetaan paikallisesti laitteellesi, voit skannata tuotteita, lisätä arvioita ja tarkastella historiaasi ilman internetyhteyttä.",
      },
      {
        question: "Voinko käyttää WasOK:ta minkä tahansa tuotteen kanssa?",
        answer:
          "Kyllä! WasOK toimii minkä tahansa tuotteen kanssa, jossa on viivakoodi. Olipa kyseessä ruoka, kosmetiikka, kodintarvikkeet, elektroniikka tai mikä tahansa muu viivakoodillinen tuote, voit skannata sen ja tallentaa mielipiteesi.",
      },
      {
        question: "Miten skannaan viivakoodin?",
        answer:
          "Avaa yksinkertaisesti WasOK-sovellus ja napauta skannauspainiketta. Suuntaa kamera tuotteen viivakoodiin, ja sovellus tunnistaa ja skannaa sen automaattisesti. Varmista, että viivakoodi on hyvin valaistu ja tarkennettu parhaan tuloksen saamiseksi.",
      },
      {
        question: "Voinko lisätä kuvia tuotearvioihini?",
        answer:
          "Kyllä! Voit liittää kuvia mihin tahansa tuotearvioon. Tämä on erityisen hyödyllistä pakkaustietojen, ainesosaluetteloiden tai muun visuaalisen tiedon muistamisessa, joka voi auttaa sinua muistamaan, miksi pidit tai et pitänyt tuotteesta.",
      },
      {
        question: "Mitä tietoja voin tallentaa tuotteista?",
        answer:
          "Voit tallentaa arvioita (1-5 tähteä), tekstimuistiinpanoja, kuvia, maksamasi hinnan, ostopaikan ja mukautettuja kategorioita. Nämä kattavat tiedot auttavat sinua tekemään perusteltuja päätöksiä ostoksia tehdessäsi.",
      },
      {
        question: "Voinko luoda ostoslistoja?",
        answer:
          "Kyllä! WasOK:n avulla voit luoda ostoslistoja jo arvioimistasi tuotteista. Tämä helpottaa muistamaan, mistä tuotteista pidit ja haluat ostaa uudelleen.",
      },
      {
        question: "Miten järjestän tuotteeni?",
        answer:
          "Voit järjestää tuotteet mukautettujen kategorioiden avulla. Voisit esimerkiksi luoda kategorioita, kuten 'Naposteltavat', 'Kahvi', 'Ihonhoito' tai 'Puhdistustuotteet'. Tämä helpottaa arviointien selaamista tyypin mukaan.",
      },
      {
        question: "Onko WasOK ilmainen käyttää?",
        answer:
          "Kyllä, WasOK on täysin ilmainen ladata ja käyttää. Sovelluksen sisäisiä ostoja, tilauksia tai piilokuluja ei ole. Uskomme, että jokaisella tulisi olla pääsy yksityiseen tapaan muistaa tuotemieltymyksensä.",
      },
      {
        question: "Onko WasOK esteetön?",
        answer:
          "WasOK on suunniteltu mahdollisimman monen käytettäväksi. Sovellus sisältää esteettömyysominaisuuksia, kuten ruudunlukijatuen, skaalautuvan tekstin ja valinnaisen korkean kontrastin tilan.",
      },
      {
        question: "Mitä tapahtuu, jos poistan sovelluksen asennuksen?",
        answer:
          "Koska kaikki tiedot tallennetaan paikallisesti laitteellesi, sovelluksen asennuksen poistaminen poistaa kaikki tuotearviosi, muistiinpanosi ja ostoslistasi. Muista viedä tietosi, jos haluat säilyttää varmuuskopion ennen asennuksen poistoa.",
      },
      {
        question: "Voinko viedä tietoni?",
        answer:
          "Kyllä, WasOK:n avulla voit viedä tietosi varmuuskopiointia varten. Voit viedä kaikki arviosi tiedostoon, jonka voit tallentaa laitteellesi tai valitsemaasi pilvitallennustilaan.",
      },
      {
        question: "Seuraako WasOK sijaintiani?",
        answer:
          "Ei, WasOK ei seuraa sijaintiasi. Vaikka voit manuaalisesti syöttää sen kaupan nimen, josta ostit tuotteen, sovellus ei käytä GPS:ää tai sijaintipalveluita.",
      },
      {
        question: "Voinko käyttää WasOK:ta useilla laitteilla?",
        answer:
          "Tällä hetkellä WasOK ei synkronoi laitteiden välillä, koska kaikki tiedot tallennetaan paikallisesti. Jokaisella laitteella on oma erillinen tietokantansa tuotteista ja arvioista.",
      },
      {
        question: "Entä jos viivakoodi ei skannaudu?",
        answer:
          "Jos viivakoodi ei skannaudu, varmista, että se on hyvin valaistu ja tarkennettu. Voit myös kokeilla puhdistaa kameran linssin. Jos viivakoodi on vahingoittunut tai epäselvä, voit ehkä syöttää viivakoodin numeron manuaalisesti.",
      },
    ],
    cta: {
      heading: "Onko sinulla vielä kysyttävää?",
      body: "Ota yhteyttä tukitiimiimme — autamme mielellämme.",
      button: "Ota yhteyttä tukeen",
    },
  },
  support: {
    pageTitle: "Tuki",
    seoTitle: "Tuki — WasOK",
    seoDescription:
      "Saa apua WasOK:n kanssa: ota yhteyttä tukeen, ilmoita virheistä ja jaa palautetta.",
    getHelp: {
      title: "Hanki Apua",
      body: "Olemme täällä auttaaksemme sinua hyödyntämään WasOK:ta parhaalla mahdollisella tavalla. Jos sinulla on ongelmia tai kysymyksiä, meillä on useita resursseja käytettävissäsi.",
    },
    faq: {
      title: "Usein Kysytyt Kysymykset",
      body: "Ennen kuin otat yhteyttä, tutustu UKK-osioomme, jossa vastaamme yleisimpiin WasOK:ta koskeviin kysymyksiin. Löydät sieltä yksityiskohtaista tietoa sovelluksen toiminnasta, tietosuojasta, tietojen tallennuksesta ja muusta.",
    },
    contact: {
      title: "Ota Yhteyttä Tukeen",
      body: "Jos et löydä etsimääsi vastausta, tukitiimimme on valmis auttamaan. Voit tavoittaa meidät osoitteessa:",
      emailLabel: "Sähköposti:",
      responseTime: "Vastaamme yleensä 24-48 tunnin kuluessa",
    },
    bugs: {
      title: "Virheiden Ilmoittaminen",
      body: "Löysitkö virheen? Arvostamme apuasi WasOK:n parantamisessa. Kun ilmoitat virheestä, sisällytä:",
      items: [
        "Yksityiskohtainen kuvaus ongelmasta",
        "Ongelman toistamiseen tarvittavat vaiheet",
        "Laitteesi malli ja Android-versio",
        "Kuvakaappaukset tai näytön tallenteet, jos mahdollista",
      ],
      sendPrefix: "Lähetä virheilmoitukset osoitteeseen:",
    },
    featureRequests: {
      title: "Ominaisuuspyynnöt",
      bodyBefore: "Onko sinulla idea uudesta ominaisuudesta? Kuulisimme mielellämme siitä! Lähetä ehdotuksesi osoitteeseen",
      bodyAfter:
        ". Vaikka emme voi toteuttaa jokaista pyyntöä, otamme kaiken palautteen huolellisesti huomioon suunnitellessamme tulevia päivityksiä.",
    },
    knownIssues: {
      title: "Tunnetut Ongelmat",
      body: "Olemme tällä hetkellä tietoisia seuraavista ongelmista ja työskentelemme korjausten parissa:",
      items: [
        "Jotkin viivakoodit eivät ehkä skannaudu heikossa valaistuksessa — kokeile taskulamppua",
        "Erittäin pitkien tuotemuistiinpanojen tallentaminen voi kestää hetken vanhemmilla laitteilla",
        "Kuvien pienoiskuvat voivat näyttää pikselöityneiltä korkearesoluutioisilla näytöillä",
      ],
    },
    appUpdates: {
      title: "Sovelluspäivitykset",
      body: "Julkaisemme säännöllisesti päivityksiä, joissa on uusia ominaisuuksia, parannuksia ja virhekorjauksia. Pidä WasOK päivitettynä Google Play Storen kautta saadaksesi uusimmat parannukset.",
    },
    community: {
      title: "Yhteisö",
      body: "Liity käyttäjäyhteisöömme, joka tekee älykkäämpiä ostopäätöksiä WasOK:n avulla. Jaa vinkkejä, esitä kysymyksiä ja ota yhteyttä muihin käyttäjiin sosiaalisissa kanavissamme.",
    },
    emergency: {
      title: "Hätätuki",
      body: 'Jos kohtaat kriittisen ongelman, joka estää sovelluksen käytön, merkitse sähköpostisi aiherivillä "KIIREELLINEN", niin priorisoimme pyyntösi.',
    },
    cta: {
      heading: "Tarvitsetko vielä apua?",
      body: "Tukitiimimme on täällä sinua varten. Älä epäröi ottaa yhteyttä mahdollisten kysymysten tai huolenaiheiden kanssa.",
      button: "Lähetä sähköpostia tuelle",
    },
  },
  advertising: {
    pageTitle: "Mainonta ja Monetisointi",
    seoTitle: "Mainonta — WasOK",
    seoDescription: "Miten WasOK suhtautuu mainontaan ja monetisointiin.",
    approach: {
      title: "Lähestymistapamme",
      body: "WasOK:ssa uskomme, että ostostottumuksesi ja tuotemielipiteesi ovat yksityisiä ja henkilökohtaisia. Liiketoimintamallimme heijastaa tätä perusarvoa.",
    },
    noAds: {
      title: "Ei Mainoksia",
      body: "WasOK ei näytä minkäänlaisia mainoksia. Emme koskaan näytä sinulle mainoksia skannaamiesi tuotteiden, antamiesi arvioiden tai minkään muun sovelluksessa luomasi tiedon perusteella. WasOK-kokemuksesi on täysin mainokseton.",
    },
    noDataSelling: {
      title: "Ei Tietojen Myyntiä",
      body: "Emme myy, vuokraa tai jaa tietojasi mainostajille, tietovälittäjille tai muille kolmansille osapuolille. Koska kaikki tietosi tallennetaan paikallisesti laitteellesi, meillä ei ole edes pääsyä niihin. Tuotearviosi, ostoslistasi ja muistiinpanosi ovat vain sinun.",
    },
    noTracking: {
      title: "Ei Seurantaa",
      body: "WasOK ei käytä seurantapikseleitä, analytiikkapalveluita tai muuta tekniikkaa, joka valvoo käyttäytymistäsi tai jakaa tietoja kolmansille osapuolille. Emme seuraa, mitä tuotteita skannaat, missä kaupoissa asioit tai miten käytät sovellusta.",
    },
    sustainability: {
      title: "Miten Pysymme Kestävinä",
      body: "Saatat ihmetellä, miten pidämme WasOK:n ilmaisena ilman mainoksia tai tietojen myyntiä. Lähestymistapamme on yksinkertainen:",
      items: [
        {
          label: "Ilmainen ja Avoin:",
          text: "WasOK on ilmainen kaikille käyttää, ilman premium-tasoja tai maksumuureja",
        },
        {
          label: "Kevyt Toiminta:",
          text: "Pidämme kustannuksemme alhaisina rakentamalla tehokasta, tietosuojaan keskittyvää ohjelmistoa",
        },
        {
          label: "Vapaaehtoiset Lahjoitukset:",
          text: "Käyttäjät, jotka rakastavat WasOK:ta, voivat tukea meitä vapaaehtoisilla lahjoituksilla",
        },
        {
          label: "Avoin Lähdekoodi:",
          text: "Voimme tarjota konsultointi- tai räätälöityjä kehityspalveluita organisaatioille",
        },
      ],
    },
    noAffiliate: {
      title: "Ei Kumppanuuslinkkejä",
      body: "WasOK ei käytä kumppanuuslinkkejä eikä saa komissioita jälleenmyyjiltä. Kun skannaat tuotteen, emme ohjaa sinua ostamaan sitä mistään. Sovellus on tarkoitettu yksinomaan henkilökohtaiseen kirjanpitoon ja päätöksentekoon.",
    },
    noPromotions: {
      title: "Ei Tuotemarkkinointia",
      body: "Emme hyväksy maksua brändeiltä tai valmistajilta niiden tuotteiden markkinointiin. WasOK ei koskaan ehdota tuotteita, korosta tiettyjä brändejä tai vaikuta arviointeihisi millään tavalla. Mielipiteesi ovat omiasi.",
    },
    partnerships: {
      title: "Kolmannen Osapuolen Kumppanuudet",
      body: "WasOK ei tee yhteistyötä markkinointiyritysten, tietojen kokoajien tai mainosverkostojen kanssa. Toimimme itsenäisesti ja asetamme yksityisyytesi kaiken muun edelle.",
    },
    future: {
      title: "Tulevaisuuden Suunnitelmat",
      body: "Olemme sitoutuneet pitämään WasOK:n mainoksettomana ja tietosuojaan keskittyvänä. Jos meidän joskus tulisi ottaa käyttöön kestävä liiketoimintamalli tulevaisuudessa, me:",
      items: [
        "Ilmoitamme kaikista muutoksista hyvissä ajoin etukäteen",
        "Emme koskaan tingi tietosuojasta tai tietoturvasta",
        "Tarjoamme aina tavan käyttää sovellusta ilman seurantaa tai mainoksia",
        "Kuuntelemme käyttäjien palautetta ja huolenaiheita",
      ],
    },
    supporting: {
      title: "WasOK:n Tukeminen",
      body: "Jos rakastat WasOK:ta ja haluat tukea tietosuojaan keskittyvää ostosmuisti-tehtäväämme, voit:",
      items: [
        "Kertoa ystävillesi ja perheellesi sovelluksesta",
        "Jättää positiivisen arvion Google Play Storeen",
        "Jakaa palautteesi ja ehdotuksesi kanssamme",
        "Harkita vapaaehtoisen lahjoituksen tekemistä (kun se on saatavilla)",
      ],
    },
    cta: {
      heading: "Kysymyksiä käytännöistämme?",
      body: "Olemme avoimia siitä, miten WasOK toimii. Jos sinulla on kysyttävää lähestymistavastamme tietosuojaan, monetisointiin tai kestävyyteen, ota yhteyttä.",
      button: "Ota Yhteyttä",
    },
  },
};
